import { cn } from "@/lib/utils";

type ProductBadgeProps = {
  text: string;
  className?: string;
};

const ProductBadge = ({ text, className }: ProductBadgeProps) => {
  const [label, ...rest] = text.split(":");
  const value = rest.join(":").trim();
  return (
    <dd
      className={cn(
        "rounded-2.5xl bg-white-secondary text-blue-light h-fit w-fit px-2 py-1 text-xs leading-3.5 font-medium whitespace-nowrap",
        className
      )}
    >
      {value ? (
        <>
          {label.trim()} : <span className="font-semibold">{value}</span>
        </>
      ) : (
        text
      )}
    </dd>
  );
};

export default ProductBadge;
